import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.FirmDEIEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.FirmDEICreate })));
const list = lazy(() => import("./List").then(m => ({ default: m.FirmDEIList })));

export default { edit, create, list };
